const numberFormat = (el) => {

    el.innerText = el
        .innerText
        .toString()
        .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');

};
Vue.directive('number-format', {
    bind(el) {

        numberFormat(el);

    },
    update(el) {

        numberFormat(el);

    }
});

Vue.directive('no-html', {
    inserted(el) {

        el.addEventListener('input', e => {

            const pattern = /<[^<]*>/g;
            const value = e.target.value;
            const matches = value.match(pattern);

            if(matches) {

                alert('HTMLタグは使えません。');
                e.target.value = value.replace(pattern, '');

                const changeEvent = new Event('input');
                e.target.dispatchEvent(changeEvent);

            }

        });

    }
});